import validateRuleName from "state/validateRuleName";

const validateFrequencyStep = ({ ruleName }) => validateRuleName(ruleName);

export default validateFrequencyStep;



// WEBPACK FOOTER //
// ./src/state/validateFrequencyStep.js